import(/* webpackMode: "eager" */ "/vercel/path0/src/app/su-kien/page.tsx");
